export default {
    fontFamily: [
        'Golos',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    h1: {
        fontFamily: 'Golos',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: 28,
        letterSpacing: '-0.24px'
    },
    h2: {
        fontFamily: 'Golos',
        fontWeight: 500,
        fontSize: 24,
        letterSpacing: '-0.24px'
    },
    h3: {
        fontFamily: 'Golos',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: 20,
        letterSpacing: '-0.06px'
    },
    h4: {
        fontFamily: 'Golos',
        fontWeight: 500,
        fontSize: 18,
        letterSpacing: '-0.06px'
    },
    h5: {
        fontWeight: 500,
        fontSize: 16,
        letterSpacing: '-0.05px'
    },
    h6: {
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: '-0.05px'
    },
    body1: {
        fontFamily: 'Golos',
        fontWeight: 500,
        fontSize: 16,
    },
    body2: {
        fontFamily: 'Golos',
        fontWeight: 'bold',
        fontSize: 14,
    },
    body3: {
        fontFamily: 'Golos',
        fontWeight: 400,
        fontSize: 16
    },
    overline: {
        fontWeight: 500
    },
};
